import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    users:[],
    loading: false,
}

const userSlice = createSlice({
  name: "user",
  initialState: initialState,
  reducers: {
    setusers(state, value) {
      state.users = value.payload;
    },
    setLoading(state, value) {
      state.loading = value.payload;
    }
  },
});

export const { setusers, setLoading} = userSlice.actions;

export default userSlice.reducer;